module.exports = __webpack_public_path__ + "static/media/footerLogo.4cd7aa8d.png";